import { gql } from "@apollo/client";
import { Wallet, walletFragment } from "./walletFragment";

// `customer` (public.clients, via account.customer_id) is the account's own client/jurisdiction
// record -- not a per-user or per-transaction address. app_user already has select permission on
// clients.address_city/address_state (filtered to the requesting user's own account), so this
// needs no Hasura permission change. Used for the generic jurisdiction city shown in
// GenerateCitation's Prefilled Details (e.g. "Sacramento, CA" for SMF) -- see
// apps/curbsuite/src/utils/userProfile.tsx.
export const accountFragment = gql`
  fragment accountFragment on account {
    holderName: holder_name
    id
    organizationName: organization_name
    ownerType: owner_type
    roleType: role_type
    parentAccountId: parent_account_id
    wallets(order_by: { created_at: desc }) {
      ...walletFragment
    }
    isFreeTrial: is_free_trial
    customer {
      addressCity: address_city
      addressState: address_state
    }
  }
  ${walletFragment}
`;

export interface Account {
  holderName: string;
  id: string;
  organizationName: string;
  ownerType: AccountOwnerType;
  roleType: AccountRoleType;
  parentAccountId: string | null;
  wallets: Wallet[];
  isFreeTrial: boolean;
  customer: {
    addressCity: string | null;
    addressState: string | null;
  } | null;
}

export type CurbPassAccountOwnerType = "individual_driver" | "fleet_operator";
export type CurbSuiteAccountOwnerType = "city" | "airport" | "bus_station";
export type AccountOwnerType = CurbPassAccountOwnerType | CurbSuiteAccountOwnerType;

export const CURB_PASS_OWNER_TYPE_OPTIONS: { value: CurbPassAccountOwnerType; label: string }[] = [
  { value: "individual_driver", label: "Individual Driver" },
  { value: "fleet_operator", label: "Fleet Operator" },
];

export type AccountRoleType = "payer" | "payee";

export default accountFragment;
